/**
 * Every in-app URL, in one place. Build links with these rather than template
 * strings, so a route can move without a grep. The matching patterns live in
 * router.tsx.
 */
export const paths = {
  home: '/',
  drill: (descriptorId: string) => `/drill/${encodeURIComponent(descriptorId)}`,
  session: (sessionId: string) => `/session/${encodeURIComponent(sessionId)}`,
  result: (sessionId: string) => `/result/${encodeURIComponent(sessionId)}`,
  diagnostics: '/diagnostics',
} as const
